
export const FALLBACK_LANG = 'en';
export const SUPPORTED_LANGUAGES = [
  'en',
  'es',
];